import { FavouriteDefinition, Value } from 'app/types-shared';
import { transformSelectedReport } from 'app/area/favourite/favourite-definition-transforms/selected-report';

export const updateDrillDownReport = (definition: FavouriteDefinition, drillDownReport: Value) => 
  transformSelectedReport({
    drillDownReport
  })(definition);
